/* @flow */

import { values } from 'lodash'

import type { RootState, Action, Role, RoleId, RolesStore } from '../types'
import { upsert, ActionRequiresPropertyError } from '../helpers'

export const INTO_ROLES_STORE: string = 'opinary/INTO_ROLES_STORE'

export function intoRolesStore(items: Array<Role>): Action {
  return {
    type: INTO_ROLES_STORE,
    items,
  }
}

export function selectRoles(rootState: RootState): Array<Role> {
  return values(rootState.rolesStore)
}

export function selectRoleById(rootState: RootState, id: RoleId): ?Role {
  return rootState.rolesStore[id]
}

export default function reducer(
  state: RolesStore = {},
  action: Action
): RolesStore {
  switch (action.type) {
    case INTO_ROLES_STORE:
      if (!action.items) {
        throw new ActionRequiresPropertyError(INTO_ROLES_STORE, 'items')
      } else {
        return upsert(state, action.items)
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/rolesStore.js